import { createServiceToken } from '@/app/di';
import type { AppointmentsService } from './infrastructure/appointments.service';

export const APPOINTMENTS_SERVICE = createServiceToken<AppointmentsService>('AppointmentsService');
